import { z } from "zod";

/**
 * Shared page/limit query for org-integration connection list endpoints
 * (flat connections, connection groups, and group items).
 */
export const organizationConnectionPaginationQuerySchema = z.object({
    limit: z.coerce.number().int().positive().max(200).default(10),
    page: z.coerce.number().int().min(0).default(0),
});

export type OrganizationConnectionPaginationQuery = z.infer<
    typeof organizationConnectionPaginationQuerySchema
>;
